// Module
var code = `<ex-multi-occurrence-maitre-details-ecran multi-occurrence-options="vm.multiOccurrenceOptions"> </ex-multi-occurrence-maitre-details-ecran> `;
// Exports
module.exports = code;